import { useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import 'swiper/css';
import 'swiper/css/navigation';

const chunksOfSix = (items) => {
  const rows = [];
  for (let index = 0; index < items.length; index += 6) rows.push(items.slice(index, index + 6));
  return rows;
};

function SliderRow({ items, label, rowNumber }) {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  return <div className={rowNumber ? 'mt-10' : ''}>
    <div className="mb-5 flex justify-end gap-3">
      <button ref={prevRef} aria-label={`Previous ${label}`} className="flex h-11 w-11 items-center justify-center rounded-lg bg-gray-700 transition hover:bg-[#2DCB2A]"><IoIosArrowBack size={20} color="#fff" /></button>
      <button ref={nextRef} aria-label={`Next ${label}`} className="flex h-11 w-11 items-center justify-center rounded-lg bg-gray-700 transition hover:bg-[#2DCB2A]"><IoIosArrowForward size={20} color="#fff" /></button>
    </div>
    <Swiper modules={[Navigation, Autoplay]} spaceBetween={20} slidesPerView={1}
      navigation={{ prevEl: prevRef.current, nextEl: nextRef.current }}
      onBeforeInit={(swiper) => { swiper.params.navigation.prevEl = prevRef.current; swiper.params.navigation.nextEl = nextRef.current; }}
      loop={items.length > 1} autoplay={{ delay: 4000, disableOnInteraction: false }}
      breakpoints={{ 640: { slidesPerView: 2 }, 900: { slidesPerView: 3 }, 1200: { slidesPerView: 4 }, 1536: { slidesPerView: 6 } }} className="news-swiper">
      {items.map((news) => <SwiperSlide key={news._id} className="h-auto">
        <a href={news.url || '#'} target={news.url && news.url !== '#' ? '_blank' : undefined} rel="noopener noreferrer" className="group flex min-h-[320px] flex-col rounded-2xl border border-gray-700 bg-[#1a1a2e] p-5 transition hover:border-yellow-500">
          <img src={news.image} alt={news.title} className="mb-4 h-36 w-full rounded-lg object-cover transition group-hover:scale-[1.02]" onError={(event) => { event.currentTarget.src = '/assets/video.webp'; }} />
          <h3 className="mb-3 line-clamp-2 text-lg font-bold text-white">{news.title}</h3>
          <p className="line-clamp-3 flex-grow text-sm text-gray-400">{news.description}</p>
        </a>
      </SwiperSlide>)}
    </Swiper>
  </div>;
}

export default function NewsSliderRows({ title, items, loading, emptyMessage = 'No news available yet.' }) {
  const rows = chunksOfSix(items);
  return <div className="mx-auto max-w-[1500px]">
    <h2 className="mb-7 text-3xl font-bold text-white">{title}</h2>
    {loading ? <div className="py-20 text-center text-white">Loading {title.toLowerCase()}...</div>
      : rows.length === 0 ? <div className="rounded-xl border border-gray-800 py-14 text-center text-gray-400">{emptyMessage}</div>
      : rows.map((row, index) => <SliderRow key={`${title}-${index}`} items={row} label={title} rowNumber={index} />)}
  </div>;
}
